import { Component, OnInit, Input, OnChanges} from '@angular/core';
import { IBid, Bid } from '../../models/IBid';
import { BidDTO } from '../../models/IBidDTO';
import { FezaDataService } from '../../services/fezadata.service';
import { AuthService } from '../../services/auth-service.service';
import { Utils } from '../../Utils';
import { ISample } from '../../models/ISample';

@Component({
  selector: 'audience-designer',
  templateUrl: './audience-designer.component.html',
  styleUrls: ['./audience-designer.component.css']
})
export class AudienceDesignerComponent implements OnInit, OnChanges {
  @Input() bidDTO: BidDTO;
  @Input() bidId: string;
  @Input() testMode: boolean;
  @Input() bidName: string;
  @Input() bidMode: string;
  @Input() iisSampleSupplierCurrency: string;
  @Input() internalJobBookNumber: string;
  @Input() feasibilityList: ISample[];

  userRoles: string;
  constructor(private fezaService: FezaDataService, private authService:AuthService) { 
  }

  ngOnInit() {
  
  }

  ngOnChanges() {

  }

  onUsersChanged(user: string) {
    this.bidDTO.userRoles = this.userRoles.split(',');
  }

  onFezaSelect(sample: ISample) {
    this.bidDTO.feasibilityId = sample === undefined ? "" : sample.feasibilityId;
  }

  indexOfFeza(id: string): number {
    return this.feasibilityList.findIndex(item => item.feasibilityId == id);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/audience-designer/audience-designer.component.ts